import React from "react";
import Seo from "../components/seo";
import Matrix from "../components/matrix";
import { getPrettyDate } from "../utils/dates";
import { NavLink, useParams } from "react-router";
import Layout from "../components/layout";
import SectionHead from "../components/newComponents/sectionHead";
import SocialMediaButtons from "../components/newComponents/socialShare";
import { useQuery } from "@apollo/client";
import { HandleQuery, NewsData } from "../queries";

export function NewsEntry()
{
    let { slug } = useParams();

    const query_state = useQuery(NewsData(slug), {fetchPolicy: 'no-cache'});
    const { complete, view } = HandleQuery(query_state);
    if(!complete) return view;
    const data = query_state.data;
    const { entry } = data; 

  const category = (entry[0].newsCategory[0]?.title && entry[0].newsCategory[0]?.title != null ? entry[0].newsCategory[0]?.title : "");
  const byline = (entry[0].byline && entry[0].byline != null ? entry[0].byline : "");
  const finalByline = `${category}${category && byline && " | "}${byline}`;

  return (
    <Layout>
      <Seo title={entry[0].displayTitle} image={entry[0].featureImage[0]?.url} />
      <div className="main">
        <section className="section-inside">
          <div className="shell">
            <SectionHead image={entry[0].featureImage[0]} heading={entry[0].displayTitle} date={getPrettyDate(entry[0].postDate)} byline={finalByline}/>
            <Matrix blocks={entry[0].bodyContent}/>
            <footer className="section__foot">
              <div className="section__socials">
                <p><strong>Share Article</strong></p>
                <SocialMediaButtons url={`${entry[0].url}`} title={`Genesis Analytics: ${entry[0].displayTitle}`} summary={entry[0].summary} twitterVia="GenesisEconomic" linkedInSource="Genesis Analytics"/>
              </div>
              <NavLink to="/news" className="section__link link-more link-more--back text-gray-3">Back to news</NavLink>
            </footer>
          </div>
        </section>
      </div>
    </Layout>
  );
}
